/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import {ClientUserProvider, ClientProvider, ReportProvider} from 'src/app/providers/index';
import {ClientUser, Helpers, Zip} from 'src/app/model';
import { SearchableItem } from 'src/app/model/interface/searchable.item';
import { SearchableSelection } from 'src/app/model/interface/searchable.selection';
import { CrmAlertComponent } from 'src/app/components/fields';

@Component({
  selector: 'page-client-user-edit',
  templateUrl: 'client-user-edit.page.html',
  styleUrls: ['client-user-edit.page.scss']
})
export class ClientUserEditPage implements OnInit, OnDestroy {
  @ViewChild('alert') alert: CrmAlertComponent;
  @Input('edit') editFlag = false;
  @Output() onCreate: EventEmitter<SearchableItem> = new EventEmitter();
  @Output() onCancel: EventEmitter<void> = new EventEmitter();
  @Input() clientUser: ClientUser = new ClientUser();
  @Input('manage') manageFlag = false;
  @Input() isLender = false;
  @Input() isOther = false;

  stateItems: SearchableItem[] = [];

  zipError: string;
  zipLoading = false;
  lastCheckedZip: string;

  constructor(
    public clientProvider: ClientProvider,
    public clientUserProvider: ClientUserProvider,
    private reportProvider: ReportProvider
  ) { }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    this.stateItems = Helpers.getDefaultStates();
  }

  onSubmit(): void {
    this.alert.hide();
    this.clientUserProvider.createClientUser( this.clientUser.CLIENT ? this.clientUser.CLIENT.ID : null, this.clientUser)
      .subscribe(data => {
        if (data.success) {
          this.onCreate.emit(ClientUser.parse(data.result));
        } else {
          if (this.clientUser.CLIENT)
            this.alert.showError('User with this Email already exists for this Bank.');
          else this.alert.showError('User with this Email already exists.');
        }
      });
  }

  actionCancel(): void {
    this.onCancel.emit();
  }

  processPresetValue(value: SearchableSelection): void {
    if (value)
      this.clientUser.STATE = value.VALUE;
    else this.clientUser.STATE = null;
  }

  searchClient(value: any): void {
    this.clientUser.CLIENT = value != null ? value.VALUE : null;
  }

  zipKeyPress(event: any): void {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar))
      event.preventDefault();
  }

  zipKeyUp(): void {
    if (this.clientUser.ZIP == null)
      return;

    if (this.clientUser.ZIP.length < 5) {
      this.clientUser.CITY = '';
      this.clientUser.STATE = '';
    }

    if (this.clientUser.ZIP.length === 5 && !this.zipLoading) {
      this.zipLoading = true;
      this.zipError = null;
      this.lastCheckedZip = this.clientUser.ZIP;

      this.reportProvider.identifyZip(this.clientUser.ZIP)
        .subscribe(
          data => {
            this.zipLoading = false;

            if (data.success)
              if (data.result) {
                const zip = Zip.parse(data.result);

                if (zip) {
                  this.clientUser.STATE = zip.STATE;
                  this.clientUser.CITY = zip.CITY;
                } else {
                  this.zipError = 'Invalid Zip Code';
                  this.clientUser.CITY = '';
                  this.clientUser.STATE = '';
                }
              } else {
                this.zipError = 'Invalid Zip Code';
                this.clientUser.CITY = '';
                this.clientUser.STATE = '';
              }
          }, () => {
            this.zipLoading = false;
            this.zipError = 'Invalid Zip Code';
            this.clientUser.CITY = '';
            this.clientUser.STATE = '';
          });
    }
  }

  /*
      Mask the inputted number in US format.
  */
  maskPhoneNumber(e, field: any = null): void {
    if (e.target.value) {
      let x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    }
    if(field)
      field = e.target.value;
  }

  engAddressChanged(value: any): void {
    if(value){
      this.clientUser.ENG_ADDRESS = "";
    }
  }
}
